module.exports = __webpack_public_path__ + "img/audi-logo.b85be853.svg";